var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-fade-up" } }, [
    !_vm.hasCookie
      ? _c(
          "div",
          { staticClass: "privacy-banner" },
          [
            _vm.$mq === "mobile"
              ? _c(
                  "div",
                  { staticClass: "privacy-banner__close" },
                  [
                    _c("icon-button", {
                      staticClass: "mobile-close",
                      attrs: {
                        icon: "close",
                        label: "Close",
                        width: "16px",
                        height: "16px",
                      },
                      on: { click: _vm.closeBanner },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "privacy-banner__disclaimer" },
              [_vm._t("default")],
              2
            ),
            _c("primary-button", {
              staticClass: "privacy-banner__cta",
              class: _vm.$mq === "mobile" ? "button--full" : "",
              attrs: { label: _vm.ctaText, secondary: "" },
              on: { click: _vm.handleClick },
            }),
            _vm.$mq !== "mobile"
              ? _c(
                  "div",
                  { staticClass: "privacy-banner__close" },
                  [
                    _c("icon-button", {
                      attrs: {
                        icon: "close",
                        label: "Close",
                        width: "16px",
                        height: "16px",
                      },
                      on: { click: _vm.closeBanner },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }